import { createFileRoute, notFound } from "@tanstack/react-router";
import { ArticlePage, ArticleNotFound, articleHead } from "@/pages/ArticlePage";
import { findPostBySlug } from "@/data/blog/posts";

export const Route = createFileRoute("/artikler/$slug")({
  loader: ({ params }) => {
    const post = findPostBySlug(params.slug, "da");
    if (!post) throw notFound();
    return { post };
  },
  head: ({ loaderData }) =>
    loaderData ? articleHead(loaderData.post, "da") : { meta: [{ title: "Artikler | MI Support" }] },
  notFoundComponent: () => <ArticleNotFound locale="da" />,
  component: RouteComponent,
});

function RouteComponent() {
  const { post } = Route.useLoaderData();
  return <ArticlePage post={post} locale="da" />;
}
